import { render, staticRenderFns } from "./levelDetails.vue?vue&type=template&id=cd38454a&scoped=true&"
import script from "./levelDetails.vue?vue&type=script&lang=js&"
export * from "./levelDetails.vue?vue&type=script&lang=js&"
import style0 from "./levelDetails.vue?vue&type=style&index=0&id=cd38454a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd38454a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd38454a')) {
      api.createRecord('cd38454a', component.options)
    } else {
      api.reload('cd38454a', component.options)
    }
    module.hot.accept("./levelDetails.vue?vue&type=template&id=cd38454a&scoped=true&", function () {
      api.rerender('cd38454a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/levelDetails.vue"
export default component.exports